var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "step-progress" },
    _vm._l(_vm.data, function(item) {
      return _c("div", { key: item.id, staticClass: "step-progress-bar" }, [
        _c("span", {
          staticClass: "step-progress-bar--item",
          class: { active: item.active, check: item.check },
          attrs: { id: item.id }
        })
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }